module.exports = __webpack_public_path__ + "static/img/t30.86d65eab.png";